export const HOMEPAGE = 'homepage';
export const INBOX = 'inbox';
